<template>
    <div>
        <vs-table
            stripe
            border
            description
            :sst="true"
            :data="table.data"
            :max-items="table.length"
            :total="table.total"
            @search="handleSearch"
            @change-page="handleChangePage"
            @sort="handleSort">
            <template slot="header">
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                    <div class="flex items-center justify-between p-3 font-medium border border-solid rounded-full cursor-pointer d-theme-border-grey-light d-theme-dark-bg">
                        <span class="mr-2">{{ this.table.start }} - {{ this.table.end }} of {{ this.table.total }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <vs-dropdown-menu>
                        <vs-dropdown-item v-for="item in table.limits" :key="item" @click="handleChangelength(item)">
                            <span>{{ item }}</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>

                <div class="con-input-search vs-table--search">
                    <input
                        type="text"
                        class="input-search vs-table--search-input"
                        placeholder="Search here"
                        v-model="search"
                        @input="onChangeSearch(search)"
                        @keyup.enter="handleSearch(search)"
                    >
                    <i class="vs-icon notranslate icon-scale material-icons null">search</i>
                </div>

                <vs-button
                    size="small"
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-search"
                    title="Search"
                    style="margin-left: 5px"
                    @click="handleSearch(search)"
                ></vs-button>
            </template>

            <template slot="thead">
                <vs-th></vs-th>
                <vs-th sort-key="">STO Doc. Num.</vs-th>
                <vs-th sort-key="">Transaction Date</vs-th>
                <vs-th sort-key="">Source Warehouse</vs-th>
                <vs-th sort-key="">Dest. Warehouse</vs-th>
                <vs-th sort-key=""># of SKU</vs-th>
                <vs-th sort-key="">Total QTY (UOM)</vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        <div class="flex vx-input-group">
                            <vs-button size="small" color="warning" icon-pack="feather" icon="icon-eye"
                                title="Detail" style="margin-right: 5px" @click="handleDetail(tr.id)" />
                            <!-- <vs-button size="small" color="success" icon-pack="feather" icon="icon-check"
                                v-if="status === 'Waiting'" title="Approve" style="margin-right: 5px" @click="handleApprove(tr.id)" />
                            <vs-button size="small" color="danger" icon-pack="feather" icon="icon-x-square"
                                v-if="status === 'Waiting'" title="Reject" @click="handleReject(tr.id)" /> -->
                        </div>
                    </vs-td>
                    <vs-td>{{ tr.code }}</vs-td>
                    <vs-td>{{ formatDate(tr.date) }}</vs-td>
                    <vs-td>{{ tr.src_warehouse_code }} {{ tr.src_warehouse_name }}</vs-td>
                    <vs-td>{{ tr.dest_warehouse_code }} {{ tr.dest_warehouse_name }}</vs-td>
                    <vs-td>{{ tr.total_sku }}</vs-td>
                    <vs-td>{{ tr.quantity_uom }}</vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <vs-pagination style="padding-top: 5px" :total="table.totalPage" v-model="setPage" />
    </div>
</template>

<script>
import moment from "moment";

export default {
    components: {},
    props: {
        draw: {
            type: Number,
        },
        sourceWarehouseId: {
            type: Number,
        },
        destWarehouseId: {
            type: Number,
        },
        transactionDate: {
            type: Date,
            default: null,
        },
        status: {
            type: String,
            default: "Waiting Approval",
        },
    },
    data() {
        return {
            deleteId: null,
            action: null,
            search: "",
            localDraw: 0,
            table: this.tableDefaultState(),
        };
    },
    methods: {
        tableDefaultState() {
            return {
                data: [],
                length: 10,
                page: 1,
                search: "",
                order: "",
                sort: "",
                total: 0,
                totalPage: 1,
                totalSearch: 0,
                limits: [10, 25, 50, 100, "All"],
                start: 1,
                end: 0,
            };
        },
        onChangeSearch(searching) {
            this.table.search = searching;
            this.table.page = 1;
        },
        handleSearch(searching) {
            this.table.search = searching;
            this.table.page = 1;
            this.localDraw++
        },
        handleChangePage(page) {
            this.table.page = page;
            this.getData();
        },
        handleSort(key, active) {
            this.table.order = key;
            this.table.sort = active;
            this.getData();
        },
        handleChangelength(val) {
            this.table.length = val == "All" ? this.table.total : val;
            this.table.page = 1;
            this.getData();
        },
        handlePlan(id) {
            this.$router.push({
                name: "customer-visit-plan",
                params: { id: id },
            });
        },
        getData() {
            if (this.draw > 0 || this.localDraw > 0) {
                this.$vs.loading();
                this.$http.get("/api/wms/v1/approval/simple-sto/approval/table", {
                    params: {
                        length: this.table.length,
                        page: this.table.page,
                        search: this.table.search,
                        order: this.table.order,
                        sort: this.table.sort,
                        source_warehouse_id: this.sourceWarehouseId,
                        dest_warehouse_id: this.destWarehouseId,
                        status: this.status,
                        transaction_date: (this.transactionDate) ? moment(this.transactionDate).format("YYYY-MM-DD") : null,
                    },
                })
                .then((resp) => {
                    if (resp.code == 200) {
                        this.table.total = resp.data.total_record;
                        this.table.totalPage = resp.data.total_page;
                        this.table.totalSearch = resp.data.total_record_search;
                        this.table.length = resp.data.total_record_per_page;
                        this.table.data = resp.data.records;
                        this.setStartEnd();
                        this.$vs.loading.close();
                    } else {
                        this.$vs.loading.close();
                        this.$vs.dialog({
                            type: "alert",
                            acceptText: `OK`,
                            color: "danger",
                            title: `Error`,
                            text: resp.message,
                        });
                    }
                })
                .catch(error => {
                    this.$vs.loading.close();
                    console.log(error);
                    this.$vs.dialog({
                        type: "alert",
                        acceptText: `OK`,
                        color: "danger",
                        title: `Something went wrong`,
                        text: error,
                    });
                });
            }
        },
        setStartEnd() {
            let valStart = this.table.length * this.table.page - this.table.length + 1;

            if (valStart > this.table.total) {
                valStart = 1;
            }

            if (this.table.total == 0) {
                valStart = 0;
            }

            let valEnd = this.table.length * this.table.page;
            if (valEnd > this.table.total) {
                valEnd = this.table.total;
            }

            if (this.table.totalSearch < this.table.total && this.table.search != "") {
                valEnd = this.table.totalSearch;
            }

            this.table.start = valStart;
            this.table.end = valEnd;
        },
        handleApprove(id) {
            this.action = "approve";
            this.deleteId = id;
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: `Confirm`,
                text: "Please confirm to approve this data",
                accept: this.actionApprove,
            });
        },
        actionApprove() {
            this.$vs.loading();
            this.$http.post("/api/wms/v1/approval/simple-sto/status/" + this.deleteId + "/" + this.action)
            .then((resp) => {
                this.$vs.loading.close();
                if (resp.code == 200) {
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        text: "The data was success approved, check approved tab.",
                        position: "top-right",
                        iconPack: "feather",
                        icon: "icon-x-circle",
                    });
                } else {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error",
                        text: resp.message,
                        position: "top-right",
                        iconPack: "feather",
                        icon: "icon-x-circle",
                    });
                }
                this.getData();
            });
        },
        handleDetail(id) {
            this.$router.push({
                name: "approval.simple-sto-detail",
                params: { id: id },
            });
        },
        handleReject(id) {
            this.action = "reject";
            this.deleteId = id;
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: `Confirm`,
                text: "Are you sure to reject this data?",
                accept: () => {
                    this.$vs.loading();
                    this.$http.post("/api/wms/v1/approval/simple-sto/status/" + this.deleteId + "/" + this.action)
                    .then((resp) => {
                        if (resp.code == 200) {
                            this.$vs.notify({
                                color: "success",
                                title: "Success",
                                text: "The data was successfully rejected",
                                position: "top-right",
                                iconPack: "feather",
                                icon: "icon-x-circle",
                            });
                        } else {
                            this.$vs.notify({
                                color: "danger",
                                title: "Error",
                                text: resp.message,
                                position: "top-right",
                                iconPack: "feather",
                                icon: "icon-x-circle",
                            });
                        }

                        this.$vs.loading.close();
                        this.getData();
                    })
                    .catch((error) => {
                        this.$vs.loading.close();
                        console.log(error);
                    });
                },
            });
        },
    },
    mounted() { },
    watch: {
        draw() {
            this.getData();
        },
        localDraw() {
            this.getData();
        },
    },
    computed: {
        setPage: {
            get() {
                return 1;
            },
            set(val) {
                this.handleChangePage(val);
            },
        },
        formatDate: () => {
            return (val) => moment.utc(val).format("YYYY-MM-DD")
        },
    },
};
</script>